export default {
  "loyaltyAdmin.workspaceAccessRequired": "Votre compte peut consulter ce commerçant, mais ne dispose pas des droits de fidélité. Un administrateur doit attribuer un rôle de fidélité pour ce commerçant ou son propriétaire ; reconnectez-vous ensuite. Les droits de paiement et financiers sont attribués séparément.",
  "loyaltyAdmin.sourceTitle": "Source de fidélité et Syrve",
  "loyaltyAdmin.sourceScope": "Les modifications concernent uniquement le marchand sélectionné.",
  "loyaltyAdmin.sourcePurpose": "Ces paramètres déterminent si les paiements utilisent la fidélité Syrve ou Coop. Ils ne sont pas nécessaires pour créer une catégorie ou émettre une carte.",
  "loyaltyAdmin.sourceChangeSettings": "Changer le système de fidélité utilisé pour les paiements",
  "loyaltyAdmin.sourceFinancial": "Source financière de fidélité",
  "loyaltyAdmin.sourceSyrveIntegration": "Intégration de fidélité Syrve",
  "loyaltyAdmin.sourceNative": "Fidélité native Coop",
  "loyaltyAdmin.sourceSyrve": "Syrve",
  "loyaltyAdmin.sourceEnabled": "Activée",
  "loyaltyAdmin.sourceDisabled": "Désactivée",
  "loyaltyAdmin.sourceSeparateNotice": "Changer de source ne désactive pas l’intégration Syrve.",
  "loyaltyAdmin.sourceAction": "Paramètre à modifier",
  "loyaltyAdmin.sourceTarget": "Nouvelle source financière",
  "loyaltyAdmin.sourceIntegrationTarget": "Nouvel état de l’intégration Syrve",
  "loyaltyAdmin.sourceReason": "Motif du changement de source ou d’intégration",
  "loyaltyAdmin.sourceReconciliation": "Confirmation de rapprochement et de préparation",
  "loyaltyAdmin.sourceRollback": "Plan de retour arrière",
  "loyaltyAdmin.sourceConsequences": "Avant modification, arrêtez les nouvelles opérations de fidélité, terminez les visites actives et rapprochez paiements et soldes. Les soldes existants et l’historique sont conservés. Les autres fonctions POS restent disponibles.",
  "loyaltyAdmin.sourceApply": "Appliquer cette modification administrative",
  "loyaltyAdmin.sourceRetry": "Réessayer la modification enregistrée",
  "loyaltyAdmin.sourceApplied": "Modification administrative confirmée et enregistrée.",
  "loyaltyAdmin.sourcePendingWork": "Le paramètre actuel est conservé. Terminez les visites et rapprochez les paiements ou opérations de fidélité en attente avant modification.",
  "loyaltyAdmin.sourceNativeUnavailable": "Le paiement natif n’est pas prêt pour les routes POS configurées. La source actuelle est conservée.",
  "loyaltyAdmin.sourceAdapterRequired": "Activez séparément l’intégration de fidélité Syrve avant de sélectionner Syrve comme source financière.",
  "loyaltyAdmin.sourceRevisionChanged": "Les paramètres ont changé. Actualisez-les et vérifiez à nouveau la modification demandée.",
  "loyaltyAdmin.sourceResultUnknown": "Le résultat n’est pas confirmé. Réessayez la même commande avant une autre modification.",
  "loyaltyAdmin.sourceEditRejected": "Revoir la modification refusée",
  "loyaltyAdmin.sourceInvalidSaved": "La modification enregistrée est illisible. Demandez à un administrateur de vérifier son résultat.",
  "loyaltyAdmin.giftFundingTitle": "Carte cadeau payante",
  "loyaltyAdmin.giftFundingNotice": "Sélectionnez une facture Gift impayée, encaissez puis vérifiez le résultat.",
  "loyaltyAdmin.giftFundingDisabled": "Le financement payant des cartes cadeaux est indisponible pour ce marchand.",
  "loyaltyAdmin.giftFundingKind": "Opération cadeau",
  "loyaltyAdmin.giftSale": "Émettre après paiement",
  "loyaltyAdmin.giftTopup": "Recharge payante",
  "loyaltyAdmin.giftInvoice": "Facture de financement cadeau",
  "loyaltyAdmin.giftSelectInvoice": "Sélectionnez une facture non payée",
  "loyaltyAdmin.giftUnnumberedInvoice": "Facture sans numéro",
  "loyaltyAdmin.giftSavedInvoice": "Facture précédemment sélectionnée",
  "loyaltyAdmin.giftRefreshInvoices": "Actualiser les factures",
  "loyaltyAdmin.giftNoInvoices": "Aucune facture non payée admissible. Créez une facture distincte pour la valeur cadeau dans le parcours de commande habituel.",
  "loyaltyAdmin.giftReason": "Motif du financement cadeau",
  "loyaltyAdmin.giftPrepare": "Préparer le paiement cadeau",
  "loyaltyAdmin.giftRetryPreparation": "Réessayer la même préparation",
  "loyaltyAdmin.giftAwaitingPayment": "En attente du paiement complet et de son reçu émis :",
  "loyaltyAdmin.giftRefreshResult": "Vérifier le paiement et le résultat cadeau",
  "loyaltyAdmin.giftCancelNotice": "La préparation peut être annulée uniquement si le serveur confirme que le paiement n’a pas commencé. Un résultat bancaire inconnu reste en attente.",
  "loyaltyAdmin.giftCancelReason": "Motif d’arrêt de la préparation",
  "loyaltyAdmin.giftCancelPreparation": "Arrêter la préparation si le paiement n’a pas commencé",
  "loyaltyAdmin.giftCanceled": "Préparation annulée. Aucune valeur cadeau ajoutée.",
  "loyaltyAdmin.giftCanceling": "Annulation en cours de vérification. Conservez cette tentative jusqu’à confirmation.",
  "loyaltyAdmin.giftCompleted": "Valeur cadeau ajoutée :",
  "loyaltyAdmin.reservedValue": "Valeur réservée",
  "loyaltyAdmin.giftAvailable": "Valeur disponible :",
  "loyaltyAdmin.giftValueExpires": "Expiration de cette valeur achetée :",
  "loyaltyAdmin.giftNext": "Commencer une autre opération cadeau",
  "loyaltyAdmin.giftRecoverNotice": "La tentative enregistrée n’a pas pu être lue. Réessayez la même préparation ou vérifiez son résultat ; n’encaissez pas à nouveau.",
  "loyaltyAdmin.giftOperationPending": "Le résultat n’est pas confirmé. Conservez cette tentative et vérifiez à nouveau. Pour réessayer une recharge, présentez le même code de carte.",
  "loyaltyAdmin.giftInvalidRecovery": "Les données de récupération cadeau sont illisibles. Demandez à un administrateur de vérifier l’opération existante avant d’en commencer une autre.",
  "loyaltyAdmin.gift": "Carte cadeau",
  "loyaltyAdmin.giftMonths": "Durée de la valeur achetée, mois",
  "loyaltyAdmin.giftPaidOnly": "Carte émise sans solde. Ajoutez la valeur séparément.",
  "loyaltyAdmin.creditGiftAmount": "Montant cadeau à ajouter",
  "loyaltyAdmin.manualGiftCredit": "Ajouter une valeur cadeau",
  "loyaltyAdmin.giftCredited": "Valeur cadeau ajoutée",
  "loyaltyAdmin.manualGiftNotice": "Crédit manuel sans paiement.",

  "loyaltyAdmin.systemAuthor": "Système",
  "loyaltyAdmin.workspaceIntro": "Cartes cadeaux, de fidélité et de réduction",
  "loyaltyAdmin.sessionChanged": "Session modifiée. Rechargez la page avant de continuer.",
  "loyaltyAdmin.ownerChanged": "Le propriétaire du commerce a changé. Rechargez la page et vérifiez le programme actuel.",
  "loyaltyAdmin.cardQr": "Code QR de la carte de fidélité",
  "loyaltyAdmin.downloadCardQr": "Enregistrer le QR de la carte",
  "loyaltyAdmin.findCard": "Trouver une carte",
  "loyaltyAdmin.cardCode": "Code exact de la carte",
  "loyaltyAdmin.exactCodeNotice": "Scannez ou saisissez le code complet de la carte.",
  "loyaltyAdmin.scanCard": "Scanner la carte",
  "loyaltyAdmin.closeCamera": "Fermer la caméra",
  "loyaltyAdmin.cameraStarting": "Démarrage de la caméra…",
  "loyaltyAdmin.cameraUnavailable": "Caméra indisponible. Autorisez son accès ou saisissez le code manuellement.",
  "loyaltyAdmin.cardLookupFailed": "Carte introuvable ou indisponible. Vérifiez le commerce et le code exact.",
  "loyaltyAdmin.recoveryUnavailable": "Les opérations de crédit sont actuellement désactivées. La demande conservée reste disponible pour le rapprochement.",
  "loyaltyAdmin.invalidRecovery": "La demande conservée ne peut pas être lue correctement. Les nouveaux crédits sont bloqués jusqu’au rapprochement du résultat réel.",
  "loyaltyAdmin.coreFinanceTitle": "Finances des cartes natives",
  "loyaltyAdmin.issuerOnlyNotice": "Seules les cartes émises par ce commerçant sont affichées ici.",
  "loyaltyAdmin.checkResult": "Vérifier le résultat",
  "loyaltyAdmin.cancelPendingCredit": "Annuler le crédit non comptabilisé",
  "loyaltyAdmin.retryCancel": "Réessayer l’annulation",
  "loyaltyAdmin.cancelledCredit": "Le crédit est annulé ; aucun point n’a été ajouté.",
  "loyaltyAdmin.committedAwaitingCore": "Le crédit est comptabilisé. Le rapprochement avec Core reste en attente ; la demande initiale est conservée.",
  "loyaltyAdmin.abortedAwaitingCore": "L’annulation est enregistrée. Le rapprochement avec Core reste en attente.",
  "loyaltyAdmin.pendingCredit": "L’opération est toujours en attente. Aucune nouvelle demande n’a été créée.",
  "loyaltyAdmin.financeUnavailable": "Les données financières sont temporairement indisponibles. La demande conservée peut être réessayée.",

  "loyaltyAdmin.title": "Cartes de fidélité",
  "loyaltyAdmin.notice":
    "Ces cartes ne sont pas encore utilisables pour payer. La fidélité Syrve existante reste disponible.",
  "loyaltyAdmin.merchant": "Commerçant",
  "loyaltyAdmin.selectMerchant": "Choisir un commerçant",
  "loyaltyAdmin.loadError": "Impossible de charger les commerçants.",
  "loyaltyAdmin.disabled":
    "La gestion de la fidélité native n’est pas encore activée dans cet environnement.",
  "loyaltyAdmin.forbidden": "Vous n’avez pas les droits nécessaires.",
  "loyaltyAdmin.changed":
    "Les données ont changé. Actualisez et vérifiez avant de réessayer.",
  "loyaltyAdmin.conflict":
    "Cette clé de requête a déjà été utilisée pour une autre opération.",
  "loyaltyAdmin.requestError":
    "Échec de la requête. Actualisez ou réessayez la requête enregistrée.",
  "loyaltyAdmin.storageRequired":
    "Autorisez le stockage de session pour conserver une requête à réessayer sans doublon.",
  "loyaltyAdmin.invalid":
    "Vérifiez les pourcentages, la valeur du point et la durée de validité.",
  "loyaltyAdmin.refresh": "Actualiser",
  "loyaltyAdmin.uncertain":
    "Le résultat n’est pas confirmé. Réessayez la même requête pour éviter un doublon.",
  "loyaltyAdmin.retry": "Réessayer la requête enregistrée",
  "loyaltyAdmin.issued": "Carte émise",
  "loyaltyAdmin.bearerWarning":
    "Gardez ce numéro secret : en mode au porteur, il autorise la dépense. Ne le publiez pas.",
  "loyaltyAdmin.hide": "Masquer le numéro",
  "loyaltyAdmin.categories": "Catégories",
  "loyaltyAdmin.version": "Version",
  "loyaltyAdmin.edit": "Modifier",
  "loyaltyAdmin.history": "Historique des règles",
  "loyaltyAdmin.reason": "Motif de la modification ou de l’émission",
  "loyaltyAdmin.issueReason": "Motif de l’émission de la carte",
  "loyaltyAdmin.companionCategory": "Deuxième catégorie (facultative)",
  "loyaltyAdmin.singleCategory": "Sans deuxième catégorie",
  "loyaltyAdmin.blockReason": "Motif du blocage ou du déblocage",
  "loyaltyAdmin.newVersion": "Nouvelle version des règles",
  "loyaltyAdmin.newCategory": "Nouvelle catégorie",
  "loyaltyAdmin.createCategory": "Créer la catégorie",
  "loyaltyAdmin.resetCategory": "Réinitialiser le formulaire",
  "loyaltyAdmin.reasonRequired": "Indiquez un motif.",
  "loyaltyAdmin.versionNotice":
    "Les cartes émises conservent leurs règles initiales.",
  "loyaltyAdmin.name": "Nom",
  "loyaltyAdmin.kind": "Type",
  "loyaltyAdmin.accumulation": "Cumul",
  "loyaltyAdmin.discount": "Remise",
  "loyaltyAdmin.rate": "Taux, %",
  "loyaltyAdmin.limit": "Plafond de paiement en points, %",
  "loyaltyAdmin.pointRate": "Valeur de 1 point",
  "loyaltyAdmin.months": "Validité du cumul, en mois",
  "loyaltyAdmin.confirmation": "Confirmation de dépense",
  "loyaltyAdmin.BEARER": "Au porteur",
  "loyaltyAdmin.PIN": "PIN",
  "loyaltyAdmin.SMS": "SMS",
  "loyaltyAdmin.ACCOUNT": "Compte client",
  "loyaltyAdmin.DYNAMIC_QR": "QR à usage unique",
  "loyaltyAdmin.excludeAccrual": "Ne pas cumuler pour",
  "loyaltyAdmin.excludeDiscount": "Ne pas appliquer de remise à",
  "loyaltyAdmin.excludeRedemption": "Ne pas payer en points pour",
  "loyaltyAdmin.removedCategory":
    "Catégorie de produits supprimée — vérifier l’exclusion",
  "loyaltyAdmin.save": "Enregistrer la version",
  "loyaltyAdmin.issue": "Émettre une carte",
  "loyaltyAdmin.category": "Catégorie",
  "loyaltyAdmin.selectCategory": "Choisir une catégorie",
  "loyaltyAdmin.more": "Charger plus",
  "loyaltyAdmin.cards": "Cartes",
  "loyaltyAdmin.blocked": "Bloquée",
  "loyaltyAdmin.active": "Active",
  "loyaltyAdmin.unblock": "Débloquer",
  "loyaltyAdmin.block": "Bloquer",
  "loyaltyAdmin.financeTitle": "Solde et opérations Coop",
  "loyaltyAdmin.selectCard": "Choisir une carte",
  "loyaltyAdmin.pendingCard": "Carte avec une demande en attente",
  "loyaltyAdmin.balance": "Solde",
  "loyaltyAdmin.available": "Points disponibles",
  "loyaltyAdmin.reserved": "Points réservés",
  "loyaltyAdmin.creditPoints": "Points à ajouter",
  "loyaltyAdmin.expiryOverride": "Modifier la date d’expiration",
  "loyaltyAdmin.expiryHint": "Vide : durée de la carte. La date choisie se termine à 23:59 UTC",
  "loyaltyAdmin.monthsUnit": "mois",
  "loyaltyAdmin.overrideReason": "Motif du changement de durée",
  "loyaltyAdmin.manualCredit": "Ajouter des points",
  "loyaltyAdmin.operations": "Opérations",
  "loyaltyAdmin.author": "Auteur",
  "loyaltyAdmin.standardExpiry": "Expiration standard",
  "loyaltyAdmin.selectedExpiry": "Expiration choisie",
  "loyaltyAdmin.credited": "Points ajoutés",
  "loyaltyAdmin.creditReceiptTitle": "Crédit confirmé",
  "loyaltyAdmin.newBalance": "Nouveau solde",
  "loyaltyAdmin.minorUnits": "unités mineures",
  "loyaltyAdmin.creditReceiptUnavailable": "Le crédit est confirmé, mais certains détails exacts du reçu n’ont pas pu être chargés. Le solde ou l’expiration manquants ne sont pas déduits.",
  "loyaltyAdmin.retryReceipt": "Charger les détails du reçu",
  "loyaltyAdmin.financeRecovery": "Le résultat est incertain. Réessayer cette demande avant un nouvel ajout.",
  "loyaltyAdmin.financeChanged": "Le solde a changé. Actualiser les données et vérifier le montant.",
  "loyaltyAdmin.financeValidation": "Saisir un montant positif selon le taux, un motif et une date future avec un motif de changement.",
  "loyaltyAdmin.pointsUnit": "points",
  "loyaltyAdmin.refreshBalance": "Actualiser le solde",
  "loyaltyAdmin.operationCREDIT": "Crédit",
  "loyaltyAdmin.operationRESERVE": "Réservation",
  "loyaltyAdmin.operationCOMMIT": "Utilisation",
  "loyaltyAdmin.operationRELEASE": "Libération",
  "loyaltyAdmin.operationREVERSE_CREDIT": "Annulation du crédit",
  "loyaltyAdmin.operationREFUND_SPEND": "Remboursement des points",
  "loyaltyAdmin.operationEXPIRE": "Expiration",
  "loyaltyAdmin.coreCategoriesTitle": "Catégories de fidélité Core",
  "loyaltyAdmin.categoryReadOnlyNotice": "Consultation seule. La modification des catégories et l’émission des cartes via Core ne sont pas encore disponibles.",
  "loyaltyAdmin.issuerCategoryNotice": "Seules les catégories de ce commerçant sont affichées.",
  "loyaltyAdmin.currency": "Devise",
  "loyaltyAdmin.giftKind": "Carte cadeau",
  "loyaltyAdmin.accrualRate": "Cumul, %",
  "loyaltyAdmin.discountRate": "Remise, %",
  "loyaltyAdmin.giftLifetime": "Validité de la valeur achetée, mois",
  "loyaltyAdmin.notConfigured": "Configuration à vérifier",
  "loyaltyAdmin.exclusionReferenceNotice": "Le nombre d’exclusions est affiché ; les noms des catégories de produits nécessitent une vérification du catalogue.",
  "loyaltyAdmin.moreHistory": "Charger les versions précédentes",
  "loyaltyAdmin.transferTitle": "Import de la liste de cartes",
  "loyaltyAdmin.transferExportPairedUnavailable": "Export indisponible : ce propriétaire possède des cartes à deux catégories. Le format actuel omettrait la seconde catégorie et son solde.",
  "loyaltyAdmin.transferExportTitle": "Export des cartes et soldes réels",
  "loyaltyAdmin.transferExportNotice": "Crée un instantané réservé au rôle financier avec les codes exacts prouvés, toutes les versions de catégories et portions de solde, les engagements Gift/promo séparés et l’activité crédits/utilisations par commerçant. L’export s’arrête si un code exact ou un solde en attente ne peut pas être prouvé.",
  "loyaltyAdmin.transferExportXlsx": "Exporter le XLSX réel",
  "loyaltyAdmin.transferExportCsv": "Exporter le CSV réel",
  "loyaltyAdmin.transferExportPreparing": "Préparation de l’instantané propriétaire…",
  "loyaltyAdmin.transferExportReady": "L’instantané vérifié a été téléchargé.",
  "loyaltyAdmin.transferNotice": "Vérification préalable uniquement. Les cartes et soldes restent inchangés ; l’import confirmé n’est pas encore disponible.",
  "loyaltyAdmin.transferTemplateNotice": "Téléchargez et remplissez le modèle. Remplacez tous les exemples de codes, soldes, dates et règles par vos données.",
  "loyaltyAdmin.transferTemplateXlsx": "Modèle XLSX",
  "loyaltyAdmin.transferTemplateCsv": "Modèle CSV (ZIP)",
  "loyaltyAdmin.transferFormat": "Format des fichiers",
  "loyaltyAdmin.transferFileLimit": "2 Mo au total. Les trois fichiers CSV sont requis ; le tableau des lots doit garder son en-tête même sans lots.",
  "loyaltyAdmin.transferCheck": "Vérifier les fichiers",
  "loyaltyAdmin.transferSave": "Enregistrer le paquet",
  "loyaltyAdmin.transferOpeningCheck": "Vérifier les soldes d’ouverture",
  "loyaltyAdmin.transferOpeningChecked": "Calcul des soldes d’ouverture vérifié",
  "loyaltyAdmin.transferOpeningBlocked": "Calcul des soldes d’ouverture bloqué",
  "loyaltyAdmin.transferOpeningAt": "Date du calcul",
  "loyaltyAdmin.transferOpeningNotice": "Calcul uniquement. Les correspondances, l’acceptation des identifiants source, les accords sur les échéances et l’application confirmée au journal restent nécessaires. Les cartes et soldes n’ont pas changé.",
  "loyaltyAdmin.transferOpeningSource": "Solde du relevé, unités mineures",
  "loyaltyAdmin.transferOpeningExpired": "Expiré depuis le relevé, unités mineures",
  "loyaltyAdmin.transferOpeningProjected": "Solde calculé, unités mineures",
  "loyaltyAdmin.transferFutureSnapshot": "La date du relevé est dans le futur. Vérifiez la date et l’heure d’origine.",
  "loyaltyAdmin.transferSaveNotice": "Enregistrer un instantané chiffré pour un rapprochement ultérieur. Cela ne crée pas de cartes, ne confirme pas l’import et ne modifie pas les soldes.",
  "loyaltyAdmin.transferSaved": "Paquet enregistré ; import non appliqué. Référence",
  "loyaltyAdmin.transferDraftConflict": "Cette demande est déjà liée à d’autres données. Vérifiez à nouveau les fichiers avant de créer un nouveau paquet.",
  "loyaltyAdmin.transferValid": "Vérification des fichiers réussie",
  "loyaltyAdmin.transferInvalid": "Vérifiez les fichiers et la devise de destination.",
  "loyaltyAdmin.transferErrors": "Erreurs",
  "loyaltyAdmin.transferWarnings": "À confirmer avant l’import",
  "loyaltyAdmin.transferMinorBalance": "Solde (unités monétaires minimales)",
  "loyaltyAdmin.transferSection_cards": "Cartes",
  "loyaltyAdmin.transferSection_categories": "Versions des catégories",
  "loyaltyAdmin.transferSection_lots": "Lots",
  "loyaltyAdmin.transferSection_package": "Paquet",
  "loyaltyAdmin.transferRow": "Ligne",
  "loyaltyAdmin.transferDuplicate": "Carte, code, version de catégorie ou lot en double.",
  "loyaltyAdmin.transferBalanceMismatch": "Le total des lots et de la dette ne correspond pas au solde.",
  "loyaltyAdmin.transferMapping": "Confirmez la destination de la carte, sa catégorie et sa version avant l’import.",
  "loyaltyAdmin.transferOpening": "Confirmez le solde initial et la politique de validité.",
  "loyaltyAdmin.transferReservations": "Rapprochez les réservations en cours avant l’import.",
  "loyaltyAdmin.transferGift": "L’application de la valeur cadeau achetée n’est pas encore disponible.",
  "loyaltyAdmin.transferCheckRow": "Vérifiez les champs, les types et les dates d’origine.",
  "loyaltyAdmin.transferFile_cards": "CSV des cartes",
  "loyaltyAdmin.transferFile_categories": "CSV des versions de catégories",
  "loyaltyAdmin.transferFile_lots": "CSV des lots",
  "loyaltyAdmin.transferFile_workbook": "Classeur XLSX",
  "loyaltyAdmin.transferSessionChanged": "La session a changé. Rechargez la page et sélectionnez à nouveau les fichiers.",
  "loyaltyAdmin.transferApplyTitle": "Confirmer l’import",
  "loyaltyAdmin.transferApplyNotice": "Crée les cartes Coop et les soldes initiaux observés, dont les cadeaux avec lots et échéances d’origine connus. Syrve et la source financière ne changent pas. Rapprochez les échéances inconnues, réservations et catégories de produits.",
  "loyaltyAdmin.transferApplyPending": "Reprendre la demande précédente",
  "loyaltyAdmin.transferApplyIssuer": "Toutes les cartes ont un émetteur ; les attribuer au commerçant sélectionné.",
  "loyaltyAdmin.transferApplyBalances": "J’ai vérifié les soldes, la dette et les échéances d’origine.",
  "loyaltyAdmin.transferApply": "Importer",
  "loyaltyAdmin.transferApplyRetry": "Réessayer l’import initial",
  "loyaltyAdmin.transferApplyCancel": "Annuler l’import non exécuté",
  "loyaltyAdmin.transferApplied": "Cartes importées",
  "loyaltyAdmin.transferApplyAborted": "Import annulé sans création de soldes.",
  "loyaltyAdmin.transferApplyLookup": "Rechercher les cartes importées",
  "loyaltyAdmin.transferApplyDone": "Terminer",
  "loyaltyAdmin.transferApplyStorage": "Impossible de sauvegarder la reprise. Aucune nouvelle demande envoyée.",
  "loyaltyAdmin.transferApplyUnknown": "Résultat inconnu. Réessayez la demande initiale ou annulez-la. Un import effectué ne sera pas inversé.",
  "loyaltyAdmin.transferApplyMappingBlocked": "Rapprochez les émetteurs ou catégories. Annulez cette demande avant de corriger le fichier.",
  "loyaltyAdmin.transferApplyConflict": "L’identité source ou le code existe déjà. Rapprochez l’import initial sans recréer le solde.",
  "loyaltyAdmin.transferApplyUnsupported": "Rapprochez les règles, échéances, réservations ou catégories de produits avant l’import.",
  "loyaltyAdmin.operationIMPORT_OPENING": "Solde initial importé",
  "loyaltyAdmin.transferApplyCategoryLimit": "La destination accepte au maximum 500 catégories. Annulez cette demande et rapprochez le fichier des catégories existantes.",
  "loyaltyAdmin.tasks": "Actions",
  "loyaltyAdmin.back": "Retour",
  "loyaltyAdmin.taskfind": "Trouver une carte",
  "loyaltyAdmin.taskcatalog": "Catalogue des cartes",
  "loyaltyAdmin.taskissue": "Émettre une carte vide",
  "loyaltyAdmin.taskcategories": "Catégories",
  "loyaltyAdmin.taskgift": "Vendre / recharger Gift",
  "loyaltyAdmin.tasksource": "Paramètres du programme",
  "loyaltyAdmin.openCard": "Ouvrir la carte",
  "loyaltyAdmin.loading": "Chargement…",
  "loyaltyAdmin.balanceRead": "Solde actualisé",
  "loyaltyAdmin.balanceDetails": "Détails du solde",
  "loyaltyAdmin.creditUnavailable": "Le crédit manuel est temporairement indisponible. Contactez l’administrateur du programme.",
  "loyaltyAdmin.issuerRequired": "Le crédit manuel est disponible auprès du commerçant émetteur.",
  "loyaltyAdmin.resumeCredit": "Reprendre le crédit",
  "loyaltyAdmin.checkoutpoints": "points",
  "loyaltyAdmin.checkoutcardBalance": "Solde de la carte",
  "loyaltyAdmin.checkoutavailableCardBalance": "Solde disponible",
  "loyaltyAdmin.checkoutreservedCardBalance": "Solde réservé",
  "loyaltyAdmin.checkoutownerCardBalance": "Solde de la carte du propriétaire",
  "loyaltyAdmin.checkoutpartCalculation": "Calcul de cette partie",
  "loyaltyAdmin.checkoutmaximumPart": "Maximum pour cette partie",
  "loyaltyAdmin.checkoutselectedValue": "Montant de carte choisi",
  "loyaltyAdmin.checkoutavailableAfter": "Disponible après paiement",
  "loyaltyAdmin.checkoutexpectedAccrual": "Points prévus",
  "loyaltyAdmin.checkoutpriceDiscount": "Remise de la carte",
  "loyaltyAdmin.checkoutgiftUsed": "Montant Gift utilisé",
  "loyaltyAdmin.checkoutpromoUsed": "Bonus utilisés",
  "loyaltyAdmin.checkoutpointsAccrued": "Points crédités",
  "loyaltyAdmin.checkoutconfirmedPayment": "Paiement par carte confirmé",
  "loyaltyAdmin.checkoutpaymentConfirmed": "Paiement par carte confirmé.",
  "loyaltyAdmin.checkoutcardUsed": "Montant de carte utilisé",
  "loyaltyAdmin.checkoutrecentHistory": "Opérations récentes de la carte",
  "loyaltyAdmin.checkoutnoOperations": "Aucune opération pour le moment.",
  "loyaltyAdmin.checkoutlookupCode": "Code de carte ou QR",
  "loyaltyAdmin.checkoutreadCard": "Lire la carte",
  "loyaltyAdmin.checkoutwithoutCard": "Continuer sans carte",
  "loyaltyAdmin.checkoutloyaltyCard": "Carte de fidélité",
  "loyaltyAdmin.checkoutloyaltyCash": "Carte et espèces",
  "loyaltyAdmin.checkoutscanCardCheckout": "Scanner la carte",
  "loyaltyAdmin.checkoutnone": "Ne pas utiliser les points",
  "loyaltyAdmin.checkoutmaximum": "Utiliser le maximum",
  "loyaltyAdmin.checkoutcustom": "Choisir les points",
  "loyaltyAdmin.checkoutamount": "Points à utiliser",
  "loyaltyAdmin.checkoutmoney": "Paiement des articles",
  "loyaltyAdmin.checkoutpointsDiscount": "Paiement en points",
  "loyaltyAdmin.checkoutprepayment": "Prépaiement Gift",
  "loyaltyAdmin.checkoutgiftTitle": "Paiement Gift",
  "loyaltyAdmin.checkoutgiftNone": "Ne pas utiliser Gift",
  "loyaltyAdmin.checkoutgiftMaximum": "Utiliser le maximum Gift",
  "loyaltyAdmin.checkoutgiftCustom": "Choisir le montant Gift",
  "loyaltyAdmin.checkoutpairedTitle": "Gift et bonus",
  "loyaltyAdmin.checkoutpairedNone": "Ne pas utiliser la carte",
  "loyaltyAdmin.checkoutpairedMaximum": "Utiliser le maximum de la carte",
  "loyaltyAdmin.checkoutpairedCustom": "Choisir le montant",
  "loyaltyAdmin.checkoutconfirmGuest": "Valider et ouvrir le paiement",
  "loyaltyAdmin.checkoutfailedGuest": "Résultat non confirmé. Vérifiez le paiement enregistré avant de réessayer.",
  "loyaltyAdmin.checkoutexpired": "Calcul expiré. Choisissez à nouveau les points.",
  "loyaltyAdmin.checkoutgiftExpired": "Calcul expiré. Choisissez à nouveau le montant Gift.",
  "loyaltyAdmin.checkoutpairedExpired": "Calcul expiré. Choisissez à nouveau le montant.",
  "loyaltyAdmin.checkoutcashTitle": "Paiement par carte",
  "loyaltyAdmin.checkoutcashGoods": "Espèces pour les articles",
  "loyaltyAdmin.checkoutcashConfirm": "Enregistrer les espèces reçues",
  "loyaltyAdmin.checkoutcashFailed": "Paiement non confirmé. Vérifiez la tentative enregistrée avant de percevoir à nouveau.",
  "loyaltyAdmin.checkoutguestPending": "Un paiement enregistré doit être vérifié. Présentez la même carte. Un délai dépassé ne l’annule pas.",
  "loyaltyAdmin.checkoutcashPending": "Paiement par carte et espèces en attente. Présentez la même carte et vérifiez avant de percevoir à nouveau.",
  "loyaltyAdmin.checkoutresumeGuest": "Reprendre le paiement enregistré",
  "loyaltyAdmin.checkoutresumeCash": "Vérifier le paiement précédent",
  "loyaltyAdmin.checkoutcancelGuest": "Annuler la validation non démarrée",
  "loyaltyAdmin.checkoutcancelCash": "Annuler la validation de carte non démarrée",
  "loyaltyAdmin.checkoutzeroGuest": "Confirmer sans supplément",
  "loyaltyAdmin.checkoutpaymentUnavailable": "Le paiement est indisponible.",
  "loyaltyAdmin.checkoutsavedPaymentUnreadable": "Impossible de lire le paiement enregistré. Contactez le personnel avant de réessayer.",
  "loyaltyAdmin.checkoutrecoveryStorageUnavailable": "Le stockage de récupération du paiement est indisponible. Contactez le personnel avant de réessayer.",
  "loyaltyAdmin.checkoutremainderUnconfirmed": "Le montant restant à payer n’est pas confirmé.",
  "loyaltyAdmin.checkoutcardBlocked": "Cette carte est bloquée.",
  "loyaltyAdmin.checkoutpaymentPendingResolution": "Le paiement est toujours en attente. Vérifiez à nouveau le paiement enregistré.",
  "loyaltyAdmin.checkoutcancellationUnconfirmed": "L’annulation n’est pas confirmée.",
  "loyaltyAdmin.checkouttipRequiresPayment": "Supprimez le pourboire pour confirmer sans supplément, ou utilisez moins de points.",
  "loyaltyAdmin.checkoutcalculationChanged": "Le calcul a changé.",
  "loyaltyAdmin.checkoutgiftAmountCurrency": "Montant Gift ({currency})",
  "loyaltyAdmin.checkoutcardAmountCurrency": "Montant de la carte ({currency})",
  "loyaltyAdmin.checkoutworking": "Traitement en cours…",
  "loyaltyAdmin.checkouttipLabel": "Pourboire",
  "loyaltyAdmin.checkoutcompleteGuestCount": "Indiquez le nombre de clients avant le paiement.",
  "loyaltyAdmin.checkoutinvalidPaymentAmount": "Le montant de paiement calculé est invalide.",
  "loyaltyAdmin.checkoutcalculationChangedRetry": "Le calcul a changé. Choisissez à nouveau le montant de points.",
  "loyaltyAdmin.checkouthistoryImportOpening": "Solde initial importé",
  "loyaltyAdmin.checkouthistoryCredit": "Valeur ajoutée",
  "loyaltyAdmin.checkouthistoryReserve": "Valeur réservée",
  "loyaltyAdmin.checkouthistoryRelease": "Réservation libérée",
  "loyaltyAdmin.checkouthistoryPayment": "Paiement",
  "loyaltyAdmin.checkouthistoryPaymentPending": "Paiement en attente",
  "loyaltyAdmin.checkouthistoryPaymentCanceled": "Paiement annulé",
  "loyaltyAdmin.checkouthistoryPaymentReturned": "Valeur du paiement restituée",
  "loyaltyAdmin.checkouthistoryAccrualReversed": "Crédit annulé",
  "loyaltyAdmin.checkouthistoryExpired": "Valeur expirée",
  "loyaltyAdmin.checkouthistoryOperation": "Opération de carte",
  "loyaltyAdmin.checkoutzeroCash": "Confirmer sans espèces pour les articles",
  "loyaltyAdmin.checkoutchoosePart": "Choisissez une partie disponible de la note pour cette carte.",
  "loyaltyAdmin.checkoutchooseCashPart": "Choisissez un montant dans le solde restant.",
  "loyaltyAdmin.checkoutattached": "Carte liée à la visite en cours.",
  "loyaltyAdmin.giftPresentSelectedCard": "Présentez la carte sélectionnée pour continuer.",
  "loyaltyAdmin.giftDifferentCard": "Il s’agit d’une autre carte. Présentez la carte sélectionnée.",
  "loyaltyAdmin.ownerReportTitle": "Rapport du propriétaire",
  "loyaltyAdmin.ownerReportNotice": "Consultez les engagements Gift et Promo actuels et l’activité des cartes sur une période. La date de fin est incluse.",
  "loyaltyAdmin.ownerReportFrom": "Du",
  "loyaltyAdmin.ownerReportTo": "Au",
  "loyaltyAdmin.ownerReportMerchant": "Commerçant de l’activité",
  "loyaltyAdmin.ownerReportAllMerchants": "Tous les commerçants du propriétaire",
  "loyaltyAdmin.ownerReportShow": "Afficher le rapport",
  "loyaltyAdmin.ownerReportInvalidPeriod": "Choisissez une période de rapport valide.",
  "loyaltyAdmin.ownerReportResult": "Résultat du rapport",
  "loyaltyAdmin.ownerReportAsOf": "Engagements au",
  "loyaltyAdmin.ownerReportObligations": "Engagements actuels",
  "loyaltyAdmin.ownerReportActivity": "Activité de la période sélectionnée",
  "loyaltyAdmin.ownerReportEmpty": "Aucune ligne pour cette sélection.",
  "loyaltyAdmin.ownerReportOutstanding": "Encours",
  "loyaltyAdmin.ownerReportAvailable": "Disponible",
  "loyaltyAdmin.ownerReportReserved": "Réservé",
  "loyaltyAdmin.ownerReportDebt": "Dette",
  "loyaltyAdmin.ownerReportCredited": "Crédité",
  "loyaltyAdmin.ownerReportReversed": "Crédit annulé",
  "loyaltyAdmin.ownerReportRedeemed": "Utilisé",
  "loyaltyAdmin.ownerReportRefunded": "Utilisation remboursée",
  "loyaltyAdmin.ownerReportNet": "Mouvement net",
  "loyaltyAdmin.ownerReportMinorUnits": "Les montants sont affichés dans la plus petite unité monétaire.",
};
